<template>
  <div class="servicecontract-information mt-1">
    <div class="row header">
      <div class="col-12 mb-3 mt-2">
        <em
          class="fas rounded-circle p-1 mr-2 color-green shadow bg-white"
          :class="editModel.isNew ? 'fa-plus' : 'fa-edit'"
        />
        <span>
          {{
            editModel.isNew
              ? 'Añadir Servicio al Contrato'
              : 'Editar Servicio del Contrato'
          }}
        </span>
      </div>
    </div>
    <div class="row body">
      <div class="col">
        <div class="col-xs-12">
          <validation-observer ref="formValidator">
            <service-information v-model="editModel" />
            <error
              v-if="customErrorMessage != null"
              :message="customErrorMessage"
              variant="no-border"
            />
          </validation-observer>
        </div>
        <div class="col-xs-12 pb-2">
          <div class="row">
            <div class="col-sm-12 col-md-12 text-right pt-3">
              <action-button
                class="mr-2 py-2 btnCancel"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger"
                @click="cancel"
              />

              <action-button
                class="py-2"
                i="fas fa-save"
                text="Guardar"
                variant="success"
                @click="save"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceInformation from './ServiceInformation';
import Error from '@/components/common/Error';

import alert from '@/mixins/alert.mixin';

export default {
  name: 'ServiceInformationAddEdit',
  components: {
    ServiceInformation,
    Error,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    disablePrimary: {
      type: Boolean,
      default: () => false,
    },
    customErrorMessage: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      editModel: Object.assign({}, this.value), //Copy the model to eliminate the reference
    };
  },
  watch: {
    value: function(newValue) {
      this.editModel = Object.assign({}, newValue); //Copy the model to eliminate the reference
    },
  },
  mounted() {},
  methods: {
    async save() {
      const isValid = await this.$refs.formValidator.validate();

      if (isValid) {
        this.editModel.cost = parseFloat(this.editModel.amount);

        this.$emit('on-saved', this.editModel);
      } else {
        //TODO: Use the stored one
        this.ShowToast('Error', 'Información incompleta. (190803)', 'error');
      }
    },
    async cancel() {
      this.$emit('on-cancel');
    },
  },
};
</script>
<style scoped>
@media (min-width: 576px) {
  .servicecontract-information .header {
    padding-left: 0.25 !important;
    padding-right: 0.25 !important;
    padding-top: 10px;
  }

  .servicecontract-information .body {
    padding-left: 0.43 !important;
    padding-right: 0.43 !important;
  }

  .servicecontract-information .btnCancel {
    float: left;
  }
}

@media (min-width: 768px) {
  .servicecontract-information .header {
    padding-left: 0.33rem !important;
    padding-right: 0.33rem !important;
  }

  .servicecontract-information .body {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .servicecontract-information .btnCancel {
    float: inherit;
  }
}

@media (min-width: 992px) {
  .servicecontract-information .header {
    padding-left: 0.66rem !important;
    padding-right: 0.66rem !important;
  }

  .servicecontract-information .body {
    padding-left: 1.75rem !important;
    padding-right: 1.75rem !important;
  }
}

@media (min-width: 1200px) {
  .servicecontract-information .header {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .servicecontract-information .body {
    padding-left: 3rem !important;
    padding-right: 3rem !important;
  }
}
</style>
